// @flow

/**
 * Scroll Service Context
 * Provides scroll service to nested components
 */

import { createContext, useContext } from 'react';

// Create context with null default
export const ScrollServiceContext = createContext<?any>(null);

/**
 * Hook to access scroll service from context
 * @returns {Object} Scroll service API
 */
export const useScrollService = () => {
  const context = useContext(ScrollServiceContext);
  if (!context) {
    throw new Error('useScrollService must be used within ScrollServiceContext.Provider');
  }
  return context;
};
